import { useState, useEffect } from "react";
// material
import { Card, Container } from "@mui/material";
// components
import Scrollbar from "../table/Scrollbar";
import TableView from "../Table";
import {
  getPayoutHistory,
  getPayoutHistoryFilterConditions,
} from "../../services/services";

import CircularLoader from "../circularLoader";
import FormSearch from "../FormSearch";

// ----------------------------------------------------------------------

export default function PayoutHistory() {
  const [payout, setPayout] = useState();
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState();
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});

  // ------------------ filterStuffies --------------------//
  const [reset, setReset] = useState(false);
  const [fLoaded, setFLoaded] = useState(false);
  const [historyGroupFilter, setHistoryGroupFilter] = useState({});

  const onFilterSubmit = (data) => {
    setLoaded(false);
    getPayoutHistory({
      setResponse: setPayout,
      setLoaded,
      filter: data,
    });
  };

  // ------------------ end of filter stuffies --------------------//

  useEffect(() => {
    if (reset) setReset(false);
  }, [reset]);

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  useEffect(() => {
    getPayoutHistoryFilterConditions(setFParams, setFLoaded);
    getPayoutHistory({
      setResponse: setPayout,
      filter: historyGroupFilter,
      setLoaded: setLoaded,
    });
  }, []);

  const formatData = (input) => {
    let tableData = [];
    input.forEach(({ id, action, merchant, payment_host }) => {
      tableData.push({
        id: id,
        merchant: merchant && merchant.name,
        payment_host: payment_host && payment_host.name,
        action: action,
      });
    });
    return tableData;
  };

  useEffect(() => {
    if (payout) {
      setTableData(formatData(payout));
    }
  }, [payout]);

  const schema = [
    {
      type: "select",
      label: "Merchant",
      param: "merchant",
      options: fParams?.merchant?.map((merchant) => ({
        name: merchant.merchant__name,
        id: merchant.merchant__id,
      }))
    },
    {
      type: "select",
      label: "Payment Host",
      param: "payment_host",
      options: fParams?.payment_host?.map((host) => ({
        name: host.payment_host__name,
        id: host.payment_host__id,
      }))
    },
    {
      type: "select",
      label: "Action",
      param: "action",
      id: false,
      options: ["Add", "Remove", "Update"]
    },
  ]

  return (
    <Container style={{ paddingLeft: 0, paddingRight: 0 }}>
      <FormSearch
        schema={schema}
        loading={!fLoaded}
        onSearch={onFilterSubmit}
      />
      {loaded ? (
        <Card>
          <Scrollbar>
            <TableView
              rows={tableData}
              link={`/3/app/details/payout~id~?action=true`}
              count={payout.length}
              query={filterName}
            />
          </Scrollbar>
        </Card>
      ) : (
        <CircularLoader />
      )}
    </Container>
  );
}
